export default __webpack_public_path__ + "static/media/Lato-Black.6cfa65c6.woff";